module.exports = __webpack_public_path__ + "img/Header-title-3-SVG.e9092561.svg";